import Home from "./Pages/Home";
import Topics from "./Pages/Topics";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Videos from "./Pages/Videos";
import Navbar from "./components/Navbar";

import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import LogReg from "./Pages/LogReg";
import { useEffect } from "react";

function App() {
  return (
    <div className="App">
      <Router>
          <Routes>
            <Route exact path="/" element={ <HomeAuth> <Home /> </HomeAuth> } />
            <Route exact path='/logreg' element={ <CheckAuth> <LogReg/> </CheckAuth>  }/> 
            <Route exact path="/course/:_id" element={<Topics />} />
            <Route exact path="/videos/:itemss" element={<Videos />} />
          </Routes>
      </Router>
    </div>
  );
}

const HomeAuth = ({ children }) => {
  const user = useSelector((state) => state.reducer.userName);
  
  if (user)
      return children;
  else
    return <Navigate to='/logreg' />;
};

const CheckAuth = ({ children }) => {
  const user = useSelector((state) => state.reducer.userName);
  console.log(user)
  if (user)
    return(<Navigate to='/' />)

  else   return children;
};

export default App;
